import React from "react";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const Root = styled(Box)(({ theme }) => ({
  color: "green",
  height: "100vh",
  width: "100vw",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#EBEDEF",
}));

const Firmado = () => {
  return (
    <>
      <Root>
        <Box>
          <Typography variant="h3" gutterBottom>
            El proceso de firma finalizó
          </Typography>
          <Typography variant="h5" gutterBottom>
            Ya puede cerrar esta ventana
          </Typography>
        </Box>
      </Root>
    </>
  );
};

export default Firmado;
